import { Moment } from 'moment';
import { HandshakeStatus } from '../enums/HandshakeStatus';
import { Handshake } from './Handshake';
import { AlgorithmSupportInfo } from './valueObjects/AlgorithmSupportInfo';
import { ClientServerInfo } from './valueObjects/ClientServerInfo';

export class SshHandshake extends Handshake {
  constructor(
    id: number,
    initiatorIp: string,
    targetIp: string,
    initiatorPort: number | null,
    targetPort: number | null,
    timestamp: Moment | null,
    status: HandshakeStatus,
    private readonly kexAlg: AlgorithmSupportInfo,
    private readonly hostKeyAlg: AlgorithmSupportInfo,
    private readonly macCSAlg: AlgorithmSupportInfo,
    private readonly macSCAlg: AlgorithmSupportInfo,
    private readonly symCSAlg: AlgorithmSupportInfo,
    private readonly symSCAlg: AlgorithmSupportInfo,
    private readonly protocolVersion: ClientServerInfo<string>,
    private readonly softwareVersion: ClientServerInfo<string>,
    private readonly softwareComments: ClientServerInfo<string>
  ) {
    super(id, initiatorIp, targetIp, initiatorPort, targetPort, timestamp, status);
  }

  getKexAlgorithms() {
    return this.kexAlg;
  }

  getServerHostKeyAlgorithms() {
    return this.hostKeyAlg;
  }

  getClientServerMacAlgorithms() {
    return this.macCSAlg;
  }

  getServerClientMacAlgorithms() {
    return this.macSCAlg;
  }

  getClientServerSymmetricEncryptionAlgorithms() {
    return this.symCSAlg;
  }

  getServerClientSymmetricEncryptionAlgorithms() {
    return this.symSCAlg;
  }

  getProtocolVersion() {
    return this.protocolVersion;
  }

  getSoftwareVersion() {
    return this.softwareVersion;
  }

  getSoftwareComments() {
    return this.softwareComments;
  }
}
